"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.interruption.hint': 'Puoi interrompere l\'agente parlando',
    'conversation.interruption.active': 'Interruzione agente...',
};
